import { debugFactory } from '@iva/debugger';
import { DEBUG_CONFIG } from '../../config.js';

const debug = debugFactory(DEBUG_CONFIG);

export { debug };
